import { useState } from "react";
import { auth } from "../Firebase";
import { GoogleAuthProvider, signInWithPopup } from "firebase/auth";
import { useNavigate } from "react-router-dom";
import { FaGoogle } from "react-icons/fa";
import toast from "react-hot-toast";

export default function Login() {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleGoogleLogin = async () => {
    setLoading(true);
    try {
      const result = await signInWithPopup(auth, new GoogleAuthProvider());
      toast.success(`Welcome, ${result.user.displayName || "Admin"}!`);
      navigate("/analytics");
    } catch (error) {
      if (error.code !== "auth/popup-closed-by-user") {
        toast.error("Google sign-in failed. Please try again.");
      }
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-card">
        <img src="/logo.png" alt="InteriorJi" className="login-logo" />
        <div className="gold-divider" />
        <p className="eyebrow mb-2">Administration portal</p>
        <h1 className="login-title">Welcome back</h1>
        <p className="login-copy">
          Sign in securely with your authorised Google account to manage InteriorJi.
        </p>
        <button
          onClick={handleGoogleLogin}
          className="google-signin-button"
          disabled={loading}
          type="button"
        >
          <FaGoogle /> {loading ? "Signing in…" : "Continue with Google"}
        </button>
        <p className="login-credit">By Circuitwave Solution LLP</p>
      </div>
    </div>
  );
}
